import { Divider, Space, Statistic } from 'antd';
import millify from 'millify';
import React from 'react';
import './Acquisitions.scss';
import { QuantumVendorDetails } from '../../../models/Supplier';

interface QuantStatProp {
  quantumSupplier?: QuantumVendorDetails;
}
export const QuantumVendorStats = ({ quantumSupplier }: QuantStatProp): React.ReactElement => {
  return (
    <div className="acquisitions mt-5">
      <Space className={'quantum-statistics-banner'} size={12} split={<Divider type="vertical" />}>
        <Statistic title="Year Founded" value={quantumSupplier?.founded_date || '--'} formatter={(value) => value} />
        <Statistic
          title="Employee Count"
          value={
            quantumSupplier?.employee_count
              ? Math.trunc(Number(quantumSupplier.employee_count)).toLocaleString('en-US')
              : '--'
          }
        />
        <Statistic
          title="HQ Location"
          value={
            quantumSupplier?.hq_address
              ? quantumSupplier.hq_address.city +
                ', ' +
                (quantumSupplier.hq_address.state || quantumSupplier.hq_address.country || '--')
              : '--'
          }
        />
        <Statistic
          title="Revenue"
          value={quantumSupplier?.revenue}
          formatter={(value) => (value ? `$${millify(Number(value), { precision: 2 })}` : '--')}
        />

        <Statistic title="Ownership" value={quantumSupplier?.company_type || '--'} />
        <Statistic title="Industry" value={quantumSupplier?.industries?.join(' - ') || '--'} />
      </Space>
    </div>
  );
};
